<script lang="ts">
	import StaticPicture from "./Picture/StaticPicture.svelte";

	export let noBandOk = "";
	export let imgPost = "";
	export let noBandDescription = "";

	/* eslint-disable svelte/no-at-html-tags */
</script>

<section class="bg-secondary text-white">
	<div class="container">
		<div class="flex flex-col gap-14 py-32 xl:flex-row xl:gap-28">
			<div class="shrink-0 max-xl:order-last">
				<StaticPicture width={548} height={201} image={imgPost} alt="Jamujam post" />
			</div>
			<div>
				<h2 class="text-md lg:text-lg">{@html noBandOk}</h2>
				<p class="text-base font-bold">{@html noBandDescription}</p>
			</div>
		</div>
	</div>
</section>
